import React from 'react'
let PropTypes = React.PropTypes
//CSS
import * as css from '../../FondosAsignados.css'
//COMPONENTS
import { RowDetalleFondo } from './RowDetalleFondo.jsx'

export class TablaDetalleFondo extends React.Component{
    constructor(props){
        super(props)
        this.rows = []
    }
    focusRow(index, nombreElemento){
        let ultimoIndex = this.rows.length-1
        let elemento = nombreElemento
        if(index<0){
            // al seleccionar "antes de la primera", se seleciona el ultimo
            this.rows[ultimoIndex].focusElemento(elemento)
        }else if(index>=ultimoIndex){
            // al seleccionar "despues de la ultima", se selecciona el primero de la siguiente columna
            if(elemento==='inputColacion_nocturna')
                elemento = 'inputViatico'
            else if(elemento==='inputViatico')
                elemento = 'inputAlojamiento'
            else if(elemento==='inputAlojamiento')
                elemento = 'inputAcercamientos'
            else if(elemento==='inputAcercamientos')
                elemento = 'inputTraslados'
            else if(elemento==='inputTraslados')
                elemento = 'inputPasajeOperador'
            else if(elemento==='inputPasajeOperador')
                elemento = 'inputOtros'
            else if(elemento==='inputOtros')
                elemento = 'inputPasajeSei'
            else if(elemento==='inputPasajeSei')
                elemento = 'inputColacion_nocturna'

            if(this.rows[0][elemento].disabled){
                this.rows[1].focusElemento(elemento)
            }else{
                this.rows[0].focusElemento(elemento)
            }
        }else{
            // no es ni el ultimo, ni el primero
            if(this.rows[index][elemento].disabled){
                if((index+1)>=ultimoIndex){
                    if(elemento==='inputColacion_nocturna')
                        elemento = 'inputViatico'
                    else if(elemento==='inputViatico')
                        elemento = 'inputAlojamiento'
                    else if(elemento==='inputAlojamiento')
                        elemento = 'inputAcercamientos'
                    else if(elemento==='inputAcercamientos')
                        elemento = 'inputTraslados'
                    else if(elemento==='inputTraslados')
                        elemento = 'inputPasajeOperador'
                    else if(elemento==='inputPasajeOperador')
                        elemento = 'inputOtros'
                    else if(elemento==='inputOtros')
                        elemento = 'inputPasajeSei'
                    else if(elemento==='inputPasajeSei')
                        elemento = 'inputColacion_nocturna'

                    if(this.rows[0][elemento].disabled){
                        this.rows[1].focusElemento(elemento)
                    }else{
                        this.rows[0].focusElemento(elemento)
                    }
                }else{
                    if(this.rows[index+1][elemento].disabled){
                        if((index+2)>=ultimoIndex){
                            if(elemento==='inputColacion_nocturna')
                                elemento = 'inputViatico'
                            else if(elemento==='inputViatico')
                                elemento = 'inputAlojamiento'
                            else if(elemento==='inputAlojamiento')
                                elemento = 'inputAcercamientos'
                            else if(elemento==='inputAcercamientos')
                                elemento = 'inputTraslados'
                            else if(elemento==='inputTraslados')
                                elemento = 'inputPasajeOperador'
                            else if(elemento==='inputPasajeOperador')
                                elemento = 'inputOtros'
                            else if(elemento==='inputOtros')
                                elemento = 'inputPasajeSei'
                            else if(elemento==='inputPasajeSei')
                                elemento = 'inputColacion_nocturna'

                            if(this.rows[0][elemento].disabled){
                                this.rows[1].focusElemento(elemento)
                            }else{
                                this.rows[0].focusElemento(elemento)
                            }
                        }else{
                            this.rows[index+2].focusElemento(elemento)
                        }
                    }else{
                        this.rows[index+1].focusElemento(elemento)
                    }
                }
            }else{
                this.rows[index].focusElemento(elemento)
            }
        }
    }
    render() {
        let cantidadFondos = this.props.semanaServicios.length+1
        return (
            <div className={"panel panel-default "+css.panelInventarios}>
                <div className={"panel-heading "+css.panelHeadingDetalle}><b>Fondos</b></div>
                <div className={"panel-body "+css.panelBodyCustom}>
                    <TablaFondo>
                        {_.range(0, cantidadFondos).map(index=>{
                            let servicio = this.props.semanaServicios[index]
                            let totales = this.props.semanaServicios.length === index? true : false
                            return <RowDetalleFondo
                                key={index}
                                index={index}
                                ref={ref=>this.rows[index]=ref}
                                focusRow={this.focusRow.bind(this)}
                                servicio={servicio}
                                totales={totales}
                                totalColacionNocturna={this.props.totalColacionNocturna}
                                totalViatico={this.props.totalViatico}
                                totalAlojamiento={this.props.totalAlojamiento}
                                totalAcercmientos={this.props.totalAcercmientos}
                                totalTraslados={this.props.totalTraslados}
                                totalPasajeOperador={this.props.totalPasajeOperador}
                                totalOtros={this.props.totalOtros}
                                puedeModificar={this.props.puedeModificar}
                            />
                        })}
                    </TablaFondo>
                </div>
            </div>
        )
    }
}
let TablaFondo = ({children}) =>
    <table className={"table table-condensed "+css.tableFixed+" "+css.panelDetalleInventarios}>
        <colgroup>
            <col className={css.colDia}/>
            <col className={css.colServicios}/>
            <col className={css.colColNoche}/>
            <col className={css.colViatico}/>
            <col className={css.colAcercamiento}/>
            <col className={css.colTraslado}/>
            <col className={css.colPasajeOperador}/>
            <col className={css.colOtros}/>
        </colgroup>
        <thead>
        <tr>
            <th className={css.thDia}>Día</th>
            <th className={css.thServicios}>Cant. Serv.</th>
            <th className={css.thColNoche}>Colación Noc.</th>
            <th className={css.thViatico}>Viático</th>
            <th className={css.thAcercamiento}>Acercamientos</th>
            <th className={css.thTraslado}>Traslados</th>
            <th className={css.thPasajeOperador}>Pasje Operador</th>
            <th className={css.thOtros}>Otros</th>
        </tr>
        </thead>
        <tbody>
        {children}
        </tbody>
    </table>


// WEBPACK FOOTER //
// ./frontEnd/operarios/fondos-asignados/detalle-fondo/distribucion/TablaDetalleFondo.jsx